// components/ui/Button.tsx
import Image from "next/image";
import Link from "next/link";
import { cva } from "class-variance-authority";
import { CTAButton } from "@/lib/assets/types";

const button = cva("inline-flex items-center gap-2 px-6 py-3 font-medium", {
  variants: {
    variant: {
      solid:
        "bg-[#EAFA35] text-[#0046A7] text-xs lg:text-sm h-14 rounded-lg py-2 md:py-[10px] px-4 md:px-6 lg:px-[24px] flex gap-2 md:gap-[12px] items-center align-middle tracking-[-0.15px] flex-shrink-0 transform transition-all duration-200 ease-in-out translate-y-0 hover:-translate-y-1 hover:shadow-[0_5px_0_0_#C2D120] active:translate-y-0 active:shadow-none",
      outline:
        "bg-[#009DFF1F] text-[#0046A7] rounded-[8px] border border-[#0095FF] text-xs lg:text-sm h-14 rounded-lg py-2 md:py-[10px] px-4 md:px-6 lg:px-[24px] flex gap-2 md:gap-[12px] items-center align-middle tracking-[-0.15px] flex-shrink-0",
      whiteText:
        "bg-[#009DFF1F] text-[#FFFFFF] rounded-[8px] border border-[#0095FF] text-xs lg:text-sm h-14 rounded-lg py-2 md:py-[10px] px-4 md:px-6 lg:px-[24px] flex gap-2 md:gap-[12px] items-center align-middle tracking-[-0.15px] flex-shrink-0",
    },
  },
  defaultVariants: { variant: "solid" },
});

export default function Button({
  label,
  href,
  variant,
  icon,
  iconPosition = "right",
}: CTAButton) {
  return (
    <Link href={href} target="_blank" className={button({ variant })}>
      {icon && iconPosition === "left" && icon}
      <span>{label}</span>
      {icon && iconPosition === "right" && icon}
    </Link>
  );
}
